// App.js
import React, { useEffect } from 'react';
import AppRouter from './AppRouter';
import { getCurrentDate } from './timeService';
import { runStreakMigration } from './streaks';
import DebugOverlay from './DebugOverlay';

function App() {
  useEffect(() => {
    // One-time streak migration: sanitize legacy play-streak date and backfill
    // the daily streak from historical daily wins. Safe to call every load.
    getCurrentDate()
      .then((today) => runStreakMigration(today))
      .catch(() => {});
  }, []);

  return (
    <>
      <AppRouter />
      <DebugOverlay />
    </>
  );
}

export default App;
